import React from 'react'
import { AppBar, Box, styled, Toolbar, Typography } from '@mui/material';
import {HashLink as Link } from 'react-router-hash-link';

const Wrapper=styled(AppBar)`
    background:#FFFFFF;
    font-family:cursive;
`
const Tool=styled(Toolbar)`
    display:flex;
    margin-left:auto;
`

const Component=styled(Typography)(({theme})=>({
    marginRight:'25px',
    fontFamily: "'Lora', serif",
    '&:hover':{
        textDecoration:'underline',
    },
    [theme.breakpoints.down('md')]:{
        marginRight:'35px'
    }
}))

const Header = () => {
  return (
    <Box>
        <Wrapper>
            <Tool>
                <Link to='#Home' smooth style={{textDecoration:'none'}}>
                <Component style={{color:'#0244BE'}}>Home</Component>
                </Link>
                <Link to='#About' smooth style={{textDecoration:'none'}}>
                <Component style={{color:'#4E5255'}}>About</Component>
                </Link>
                <Link to='#Skill' smooth style={{textDecoration:'none'}}>
                <Component style={{color:'#4E5255'}}>Skills</Component>
                </Link>
                <Link to='#Project' smooth style={{textDecoration:'none'}}>
                <Component style={{color:'#4E5255'}}>Project</Component>
                </Link>
                <Link to='#Contact' smooth style={{textDecoration:'none'}}>
                <Component style={{color:'#4E5255'}}>Contact</Component>
                </Link>

            </Tool>
        </Wrapper>
    </Box>
  )
}

export default Header
